import { useRef, useState } from "react";
import { Upload, FileSpreadsheet, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function FileUpload({ onUpload, uploading, compact }) {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);

  const handleFiles = (files) => {
    if (files && files[0]) onUpload(files[0]);
  };

  if (compact) {
    return (
      <div>
        <input
          ref={inputRef}
          type="file"
          accept=".csv,.xlsx,.xls,.txt"
          className="hidden"
          data-testid="file-input-compact"
          onChange={(e) => handleFiles(e.target.files)}
        />
        <button
          data-testid="upload-new-btn"
          disabled={uploading}
          onClick={() => inputRef.current?.click()}
          className="inline-flex items-center gap-2 rounded-sm border border-border bg-secondary px-3 h-9 text-xs font-medium hover:bg-accent transition-colors disabled:opacity-50"
        >
          {uploading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}
          Upload statement
        </button>
      </div>
    );
  }

  return (
    <div
      data-testid="file-dropzone"
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); handleFiles(e.dataTransfer.files); }}
      onClick={() => inputRef.current?.click()}
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-sm border border-dashed px-6 py-16 cursor-pointer transition-colors",
        drag ? "border-green-500 bg-green-500/5" : "border-border hover:border-neutral-500 hover:bg-white/[0.02]"
      )}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".csv,.xlsx,.xls,.txt"
        className="hidden"
        data-testid="file-input"
        onChange={(e) => handleFiles(e.target.files)}
      />
      <div className="flex h-12 w-12 items-center justify-center rounded-sm border border-border bg-secondary">
        {uploading ? <Loader2 className="h-5 w-5 animate-spin" /> : <FileSpreadsheet className="h-5 w-5 text-neutral-300" />}
      </div>
      <div className="text-center">
        <p className="text-sm font-medium">
          {uploading ? "Parsing your statement…" : "Drop your CommBank statement here"}
        </p>
        <p className="mt-1 text-xs text-muted-foreground">
          CSV or Excel (.xlsx / .xls) — headerless or header-based exports
        </p>
      </div>
      {!uploading && (
        <span className="mt-1 inline-flex items-center gap-2 rounded-sm bg-white px-4 h-9 text-xs font-semibold text-black">
          <Upload className="h-3.5 w-3.5" /> Choose file
        </span>
      )}
    </div>
  );
}
